var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTovaryDliaDoma = function SvgTovaryDliaDoma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.5}.st1{fill:#fdeef3}.st2{fill:#db1683}.st3,.st4{fill:none;stroke:#db1683;stroke-width:1.75;stroke-miterlimit:10}.st4{stroke-linecap:round}.st6{fill:#e6f3ef}.st7{fill:#5eb9aa}")), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#f0eff8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 11.3h-6.5l3-2.4c.4-.3.4-.9.1-1.2-.3-.4-.9-.4-1.2-.1L20 11l-4.2-3.5c-.4-.3-.9-.3-1.2.1-.3.4-.3.9.1 1.2l2.9 2.5h-6.4c-1.1 0-1.9.9-1.9 1.9v13.6c0 1.1.9 1.9 1.9 1.9H29c1.1 0 1.9-.9 1.9-1.9V13.2c0-1.1-.9-1.9-2-1.9zm.2 15.5c0 .1-.1.2-.2.2H11.2c-.1 0-.2-.1-.2-.2V13.2c0-.1.1-.2.2-.2H29c.1 0 .2.1.2.2v13.6z",
    style: {
      fill: "#57368c"
    }
  }));
};
export default SvgTovaryDliaDoma;